import {ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AuthInterceptorService} from "./services/auth-interceptor.service";
import {IsAuthenticatedAuthGuard} from "./auth-guards/is-authenticated-auth-guard";
import {IsTefcaModeAuthGuard} from "./auth-guards/is-tefca-mode-auth-guard";
import {
  PreventBrowserHistoryNavigationGuard
} from './auth-guards/prevent-browser-history-navigation-guard';
import {
  PreventTefcaPreDashboardHistoryNavigationGuard
} from './auth-guards/prevent-tefca-pre-dashboard-history-navigation-guard';
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {provideAnimations} from "@angular/platform-browser/animations";
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import {SentryContextService} from "./services/sentry-context.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
      // deps: [AuthService, NavOutletService]
      // deps: [AuthService, NavOutletService]
    },
    IsAuthenticatedAuthGuard,
    IsTefcaModeAuthGuard,
    PreventBrowserHistoryNavigationGuard,
    PreventTefcaPreDashboardHistoryNavigationGuard,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(), // <- required for animations to work
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      context: 'stitch-embed',
    })),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(SentryContextService);
      inject(Sentry.TraceService);
    }),
  ]
};
